import { useEffect, useState } from "react";
import { Modal, Spin, message } from "antd";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import TrackerService from "../services/tracker.service";

const containerStyle = { width: "100%", height: "350px" };

const mapOptions = {
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: true,
    zoomControl: true,
    gestureHandling: "greedy",
};

export default function TrackerLocationModal({ trackerId, trackerNum, visible, onClose })
{
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: "AIzaSyBRHVJET38Cx1CGYAkiErRdKh7gi2V4etM",
    });

    useEffect(() =>
    {
        if (!visible || !trackerId) return;
        setLoading(true);
        setData(null);
        TrackerService.pingTracker(trackerId)
            .then(r =>
            {
                const result = r?.data;
                console.log(result);
                if (!result?.success)
                    message.error(result?.message || "Erreur lors du ping du tracker");
                setData(result?.data);
            })
            .finally(() => setLoading(false));
    }, [visible, trackerId]);

    const position =
        data?.latitude != null && data?.longitude != null
            ? { lat: Number(data.latitude), lng: Number(data.longitude) }
            : null;

    return (
        <Modal
            title={`Tracker #${trackerNum} — ${trackerId}`}
            open={visible}
            onCancel={onClose}
            footer={null}
            width={620}
            destroyOnClose
        >
            {loading && (
                <div style={{ textAlign: "center", padding: 32 }}>
                    <Spin />
                </div>
            )}
            {
                !loading && (
                position && isLoaded ? (
                    <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={position}
                        zoom={15}
                        options={mapOptions}
                    >
                        <Marker position={position} />
                    </GoogleMap>
                ) : (
                    <div style={{ textAlign: "center", color: "#888", padding: 16 }}>
                        {data?.message || "Aucune position disponible."}
                    </div>
                )
            )}
        </Modal>
    );
}
